export const AddCategoryURL = '/category';
export const GetAllCategoryURL = '/category';
export const GetByIdCategoryURL = '/category';
export const UpdateCategoryURL = '/category';
export const ActiveCategoryURL = '/category/status';

export const AddMarquee = '/marquee';
export const GetAllMarquee = '/marquee';
export const UpdateMarquee = '/marquee';
export const GetByIdMarquee = '/marquee';
export const GetMarqueeByType = '/marquee/marqueeType/';


export const AddImageURL = '/gallery';
export const GalleryByIdURL = '/gallery';

export const YoutubeURL = '/youtubelink';

export const ProductURL = '/product';
export const ProductByCatIdURL = '/product/category';
export const ActiveProdListURL = '/product/status';


export const fileUpload = '/uploadFile';



export const testUrl = '/myTest';

export const LoginURL = '/user/login';
export const GetUserByIdURL = '/user';
export const UserUpdateURL = '/user';

export const RandomProductURL = '/product/random';

export const SendEmailURL = '/sendEmail';
export const AllSendEmailURL = '/sendEmail';